@import url("https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css"); 
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"); 
/* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */


.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  /* display: block;  */
   /* width: 80%;
  height: 80%; */
  /* object-fit: cover; */
  margin-bottom: 40px;

}

.swiper-pagination-bullet {
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color: #000;
  opacity: 1;
  background: rgba(0, 0, 0, 0.2);
}

.swiper-pagination-bullet-active {
  color: #fff;
  background: #007aff;
}

.swiper-button-next:after, .swiper-button-prev:after {
  font-size: 20px;
  text-transform: none!important;
  letter-spacing: 0;
  font-variant: initial;
  line-height: 1;
  color: red;
}

.swiper-button-prev:after, .swiper-button-next:after {
  font-size: 20px;
  text-transform: none!important;
  letter-spacing: 0;
  font-variant: initial;
  line-height: 1;
  color: red;
}
